import * as shoppingCartActionTypes from 'constants/ShoppingCart';

export function setSelectedOrder(orderIndex) {
  return {
    type: shoppingCartActionTypes.SET_SELECTED_ORDER,
    payload: orderIndex,
  };
}
